var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.enquiry !== null)?_c('quote-form',{attrs:{"enquiry":_vm.enquiry},on:{"quote-saved":_vm.handleQuoteSaved}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }